"use client";

import React from "react";
import { Autocomplete, AutocompleteItem } from "@heroui/autocomplete";
// import { useFilter } from "@react-aria/i18n";
import { getCardImage } from "@/lib/games/onePiece/getCardDataLocal";
import { OPItem } from "@/interfaces/CardItem";

import { search } from "@/components/Searchbar/search";
import { useRouter } from "next/navigation";
import { SearchIcon } from "@/components/Searchbar/SearchIcon";
import CardArt from "@/components/Card/CardArt";

interface FieldState {
  selectedKey: string;
  inputValue: string;
  items: OPItem[];
}

interface Props {
  placeholder?: string; // Making placeholder optional
}

export default function App({ placeholder }: Props) {
  // Store Autocomplete input value, selected option, open state, and items
  // in a state tracker
  const [fieldState, setFieldState] = React.useState<FieldState>({
    selectedKey: "",
    inputValue: "",
    items: [],
  });
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const [goToFirstElement, setGoToFirstElement] = React.useState(true);

  const router = useRouter();

  // Implement custom filtering logic and control what items are
  // available to the Autocomplete.
  // const { startsWith } = useFilter({ sensitivity: "base" });

  // (e: FocusEvent<HTMLInputElement>) => void
  const onBlurChange = () => {
    setSelectedIndex(0);
  };

  const onKeyDown = (e: any) => {
    var key = e.key;
    if (e.key === "Escape") {
      const activeElement = document?.activeElement as HTMLElement | null;
      activeElement?.blur();
    }

    if (key == "ArrowDown") {
      setSelectedIndex((prevState: number) => {
        return prevState + 1;
      });
    }

    if (key == "ArrowUp") {
      setSelectedIndex((prevState) => {
        return prevState + 1;
      });
    }

    if (key == "Enter") {
      //     // handle if something else is selected
      if (selectedIndex === 0) {
        if (fieldState.items.length > 0) {
          const item = fieldState.items[0] as OPItem;
          goToLink(`/card/${item.id}`);
        }
      }
    }
  };

  // const onFocusChange = ()

  const goToLink = (url: string) => {
    router.push(url);
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }

    setFieldState((prevState) => {
      // let selectedItem = prevState.items.find((option:OPItem) => option.id === key);
      // console.log("selectedItem", selectedItem);

      // let query = prevState.inputValue;
      // let searchResults = search(query).slice(0, 10);
      // console.log(searchResults);
      const newState = {
        selectedKey: "",
        inputValue: "",
        items: prevState.items,
      };
      return newState;
    });
  };

  // Specify how each of the Autocomplete values should change when an
  // option is selected from the list box
  const onSelectionChange = (key: any) => {
    if (key === null || key === undefined || key === "") {
      return;
    }
    goToLink(`/card/${key}`);
  };

  function createKey(item: any): string {
    return `${item.groupId}/${item.id}`;
  }

  // Specify how each of the Autocomplete values should change when the input
  // field is altered by the user
  const onInputChange = (value: string) => {
    setGoToFirstElement(true);
    let query = value;
    let searchResults = search(query);

    let selectedKey: string = "";
    // always set first as selected
    // if (searchResults.length > 0) {
    //     selectedKey = createKey(searchResults[0]);
    // }
    setFieldState(
      (prevState) =>
        ({
          inputValue: query,
          selectedKey: selectedKey,
          items: query === "" ? [] : searchResults,
        }) as { inputValue: string; selectedKey: string; items: OPItem[] },
    );
  };

  // Show entire list if user opens the menu manually
  // const onOpenChange = (isOpen, menuTrigger) => {
  //     if (menuTrigger === "manual" && isOpen) {
  //         setFieldState((prevState) => ({
  //             inputValue: prevState.inputValue,
  //             selectedKey: prevState.selectedKey,
  //             items: [],
  //         }));
  //     }
  // };

  return (
    <>
      <Autocomplete
        maxLength={50}
        className="max-w-xs"
        allowsCustomValue
        startContent={<SearchIcon width={20} height={20} />}
        // allowsEmptyCollection={false}
        isVirtualized={false}
        shouldCloseOnBlur={true}
        onBlur={onBlurChange}
        inputValue={fieldState.inputValue}
        items={fieldState.items}
        // inputProps={{ classNames: { input: "text-base" } }}
        // label="Favorite Animal"
        size="md"
        aria-label="Searchbar"
        placeholder={placeholder || "Search"}
        selectedKey={fieldState.selectedKey}
        // variant="bordered"
        onInputChange={onInputChange}
        // onOpenChange={onOpenChange}
        disableSelectorIconRotation
        onSelectionChange={onSelectionChange}
        onKeyDown={onKeyDown}
      >
        {(item) => (
          <AutocompleteItem key={`${item.number}`} textValue={item.name}>
            <div className="flex flex-row items-center">
              <div className="w-1/5">
                <CardArt
                  alt={item.name}
                  src={getCardImage(item.id, "158x220")}
                  width={40}
                  radiusClassName="rounded-[2px]"
                />
              </div>
              <div className="w-4/5">
                <div className="ml-2">
                  <div>{item.name}</div>
                  <div>{item.number}</div>
                </div>
              </div>
            </div>
          </AutocompleteItem>
        )}
      </Autocomplete>
      {/* <div>
                {fieldState.selectedKey}
                {fieldState.inputValue}
                {fieldState.items.length}
            </div> */}
    </>
  );
}
